var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _vm._l(_vm.links, function(item, index) {
        return _c(
          "div",
          { key: index, staticStyle: { display: "inline" } },
          [
            _vm.$route.name !== item.path
              ? _c(
                  "v-btn",
                  {
                    staticClass: "mr-2",
                    attrs: { color: item.color, dark: "", dense: "" },
                    on: {
                      click: function($event) {
                        return _vm.$router.push(item.params)
                      }
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(item.text))])]
                )
              : _vm._e()
          ],
          1
        )
      }),
      _c("router-view", { staticClass: "mt-2" })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }